module.exports = __webpack_public_path__ + "fonts/CabinetGrotesk-Light.46ba2f9f.ttf";